module.exports = __webpack_public_path__ + "static/media/no-text-preto.f27fd38b.svg";